<form [formGroup]="form" fxLayout="column" fxLayoutAlign="start start" class="w-100">
    @if (showTitle) {
        <div class="t2-semi-bold">
            {{ 'i18n_af_labelAdditionalFiles' | translate }}{{ required ? ' *' : '' }}
        </div>
    }
    @for (filesForm of form.controls.attachments.controls; track filesForm; let first = $first; let index = $index) {
        <af-file
            [form]="filesForm"
            class="w-100"
            [hintTranslationKey]="hintTranslationKey"
            [label]="label"
            [documentAttachment]="attachments?.length && attachments[index]"
            [mimeTypes]="mimeTypes"
            [multiple]="multiple"
            [maxFileSize]="maxFileSize"
            [dropZoneStyle]="dropZoneStyle"
            [class.mt-24]="!first"
            [bucket]="bucket"
            [parentDictionaryFormControl]="parentDictionaryFormControl"
            [filterDictionaryBy]="filterDictionaryBy"
            [excludeFromDictionary]="excludeFromDictionary"
            [excludeItemsWithCode1]="excludeItemsWithCode1"
            [defaultDocType]="defaultDocType"
            [class.mt-28]="first && showTitle"/>
    }
    @if (form.hasError('required') && form.touched) {
        <div class="t5 c-secondary-red-900 mt-4">
            {{ 'i18n_af_fieldValidationAttachDocument' | translate }}
        </div>
    }
    @if (hasAddButton) {
        <ui-kit-button type="text"
                       class="mt-24"
                       fxFlexAlign="start"
                       iconPosition="left"
                       [disabled]="form.disabled"
                       [label]="'i18n_af_buttonAddDocument' | translate"
                       icon="ic_add_circle"
                       (clickListener)="addNewFile()"/>
    }
</form>
